import {
  SET_INTERFACE,
  SET_ENABLE_UPDATE_INSIGHTS,
  SET_ENABLE_UPDATE_TARGET_HEADER_DATA,
  SHOW_UE_MODAL,
  SET_LOADING_INSIGHTS,
  TOGGLE_MOCK_DATA,
  SET_QUERY,
  RESET,
  LOG_XANDR_ACTION,
  SHOW_SAVING_LIVE_DIGITAL_PROMPT,
  SET_CONTROL_URL,
  SET_QUERY_ERRORED_OUT,
  SET_TRAITS,
  SHOW_MODELING_MODAL
} from './actions'

import {XANDR_DEFAULT_STATE} from './index'
import Toast from '@/components/common/toasts'
import StayOnPageControl from '@/clientLogic/history/StayOnPageControl.js'

const mutations = {
  [SHOW_MODELING_MODAL]: (state) => {
    state.showModelingModal = state.showModelingModal + 1
  },
  [SET_INTERFACE]: (state, inter) => {
    state.interface = inter
  },
  [SET_ENABLE_UPDATE_INSIGHTS]: (state, setValue) => {
    state.enableUpdateInsights = setValue
  },
  [SET_ENABLE_UPDATE_TARGET_HEADER_DATA]: (state, setValue) => {
    state.enableUpdateTargetHeaderData = setValue
  },
  [SHOW_UE_MODAL]: (state) => {
    state.ueModalShower = state.ueModalShower + 1
  },
  [SHOW_SAVING_LIVE_DIGITAL_PROMPT]: (state) => {
    state.liveDigitalPromptShower = state.liveDigitalPromptShower + 1
  },
  [SET_LOADING_INSIGHTS]: (state, value) => {
    state.loadingInsights = value
  },
  [TOGGLE_MOCK_DATA]: (state, value) => {
    state.useMockData = value || !state.useMockData
  },
  [SET_QUERY]: (state, query) => {
    state.query = query
  },
  [RESET]: (state) => {
    for (let key of Object.keys(XANDR_DEFAULT_STATE)) {
      state[key] = XANDR_DEFAULT_STATE[key]
    }
  },
  [LOG_XANDR_ACTION]: (state, value) => {
    console.log('logged xandr action!', value)
  },
  [SET_QUERY_ERRORED_OUT]: (state, value) => {
    state.queryErroredOut = value
  },
  [SET_TRAITS]: (state, traits) => {
    state.traits = traits
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/app/appLogic/workbench/Xandr/store/mutations.js